'use client';
/**
 * search_unify1 s-ui — 홈 히어로 칩 줄. 서버 HTML·전국 = 기존 시도 칩(Hero 의 .ds2-chips 와 같은 마크업 · 방문자 무관).
 * 수화 뒤 지역(기억)이 있고 인기 검색어가 있으면 「{지역} 인기」 라벨 + 순위 칩(가로 스크롤 · 칩 누름 = 같은 검색 /search?q=&src=hero).
 * 순위만(수치 비노출) · 「실시간」 금지.
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { useEffect, useState } from 'react';
import { currentScope, readRegionMemory, type ScopeNode } from '@/lib/nav/region-scope';
import { REGION_MEMORY_EVENT } from '@/components/nav/GlobalRegionChip';
import { useNavData } from '@/components/nav/nav-data-context';
import { usePopularRegion } from '@/lib/search/use-pop-region';
import { popularArgs, searchHref } from '@/lib/search/pop-region';

export interface HeroChip { label: string; href: string; current?: boolean }

export function useScopeNode(): ScopeNode | null {
  const { headerRegion } = useNavData();
  const [node, setNode] = useState<ScopeNode | null>(null);
  useEffect(() => {
    const sync = () => setNode(currentScope(headerRegion, window.location.pathname, window.location.search, readRegionMemory()).node);
    sync();
    window.addEventListener(REGION_MEMORY_EVENT, sync);
    return () => window.removeEventListener(REGION_MEMORY_EVENT, sync);
  }, [headerRegion]);
  return node;
}

export function SidoChips({ chips, ariaLabel = '시도 바로가기' }: { chips: readonly HeroChip[]; ariaLabel?: string }) {
  const ch = chips.filter((c) => c.label && c.href).slice(0, 6);
  if (!ch.length) return null;
  return (
    <ul className="ds2-chips" aria-label={ariaLabel}>
      {ch.map((c) => (
        <li key={c.href}><a href={c.href} {...(c.current ? { 'aria-current': 'page' as const } : {})}>{c.label}</a></li>
      ))}
    </ul>
  );
}

export default function HomeHeroChips({ chips }: { chips: readonly HeroChip[] }) {
  const node = useScopeNode();
  const a = popularArgs(node);
  const pop = usePopularRegion(a.region, a.sigungu, !!node);
  const kws = node && pop ? pop.keywords.slice(0, 10) : [];
  if (!kws.length) return <SidoChips chips={chips} />;
  const label = pop?.label || a.sigungu || a.region || '';
  return (
    <div className="kd-popchips" data-popchips="">
      <span className="kd-popchips__lb">{label} 인기</span>
      <ul aria-label={`${label} 인기 검색어`}>
        {kws.map((k) => (
          <li key={k.keyword}><a href={searchHref(k.keyword, 'hero')}><b>{k.rank}</b> {k.label}</a></li>
        ))}
      </ul>
    </div>
  );
}
